import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row gap-2 items-center"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  key: 1,
  class: "flex gap-2 items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "h-px my-4 bg-gray-200 border-0 dark:bg-gray-700" }, null, -1)
const _hoisted_5 = { class: "flex flex-col gap-10 mt-2 mx-2 mb-12" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex justify-between items-center" }
const _hoisted_8 = ["checked", "disabled"]
const _hoisted_9 = { class: "ml-3 text-sm font-medium text-gray-900" }
const _hoisted_10 = { class: "py-3" }
const _hoisted_11 = { class: "text-sm font-medium leading-6 text-gray-900" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "py-2"
}
const _hoisted_14 = { class: "text-red-500" }
const _hoisted_15 = {
  key: 1,
  class: "flex pt-4 gap-2 justify-end"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "border-t border-solid border-gray-200"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_DateTime = _resolveComponent("DateTime")!
  const _component_PlannerComments = _resolveComponent("PlannerComments")!
  const _component_SlideOver = _resolveComponent("SlideOver")!

  return (_openBlock(), _createBlock(_component_SlideOver, {
    open: _ctx.mode !== 'hide',
    onClosed: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('cancelEdit'))),
    maxWidth: "1000px"
  }, {
    title: _withCtx(() => [
      (!_ctx.isEditingName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.eventRecord.name), 1),
            _createVNode(_component_PencilIcon, {
              class: "w-4 h-4 text-gray-600 cursor-pointer",
              onClick: _ctx.handleEditNameClick,
              style: {"flex-shrink":"0"}
            }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isEditingName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editingName) = $event)),
              ref: "editingNameRef",
              onKeydown: [
                _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleNameEditingConfirm && _ctx.handleNameEditingConfirm(...args)), ["enter"])),
                _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.isEditingName = false), ["stop"]), ["esc"]))
              ],
              class: "px-2 py-1 border-gray-300 rounded focus:border-yellow-500 focus:ring-0"
            }, null, 544), [
              [_vModelText, _ctx.editingName]
            ]),
            _createVNode(_component_CheckIcon, {
              class: "w-5 h-5 cursor-pointer",
              onClick: _ctx.handleNameEditingConfirm
            }, null, 8, ["onClick"]),
            _createVNode(_component_XMarkIcon, {
              class: "w-5 h-5 cursor-pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEditingName = false))
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_4
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.mode === 'edit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center flex-1 py-3", {
                'cursor-pointer': _ctx.eventRecord.type === 'planned',
              }]),
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleMilestone && _ctx.toggleMilestone(...args)))
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.isMilestone,
                    class: "h-4 w-4 rounded border-gray-300 text-gray-600",
                    disabled: _ctx.eventRecord.type === 'actual'
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("analytics.planner.milestone")), 1)
                ], 2),
                _createElementVNode("div", {
                  class: "px-2 py-1 text-white text-xs",
                  style: _normalizeStyle(`background-color: ${_ctx.eventTitleColor}`)
                }, _toDisplayString(_ctx.eventTitle), 5)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_DateTime, {
                  name: "startDate",
                  value: _ctx.startDate,
                  onChanged: _cache[5] || (_cache[5] = ($event: any) => {
                _ctx.startDate = $event;
                _ctx.calculateWorkingDays();
              }),
                  timeDisabled: true,
                  dateLabel: _ctx.$t('analytics.planner.start_date'),
                  timeLabel: _ctx.$t('analytics.planner.start_time'),
                  cls: "py-3",
                  disabled: _ctx.eventRecord.type === 'actual'
                }, null, 8, ["value", "dateLabel", "timeLabel", "disabled"]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("analytics.planner.working_days_input_label")), 1),
                  _withDirectives(_createElementVNode("input", {
                    disabled: _ctx.isMilestone || _ctx.eventRecord.type === 'actual',
                    type: "number",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.workingDays) = $event)),
                    onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleWorkingDaysInput && _ctx.handleWorkingDaysInput(...args))),
                    step: "0.5",
                    style: {"width":"182px"},
                    class: "rounded border-gray-300 focus:border-yellow-500 focus:ring-0 customInput disabled:bg-gray-100"
                  }, null, 40, _hoisted_12), [
                    [_vModelText, _ctx.workingDays]
                  ])
                ]),
                _createVNode(_component_DateTime, {
                  name: "endDate",
                  value: _ctx.endDate,
                  onChanged: _cache[8] || (_cache[8] = ($event: any) => {
                _ctx.endDate = $event;
                _ctx.calculateWorkingDays();
              }),
                  disabled: _ctx.isMilestone || _ctx.eventRecord.type === 'actual',
                  timeDisabled: true,
                  dateLabel: _ctx.$t('analytics.planner.end_date'),
                  timeLabel: _ctx.$t('analytics.planner.end_time'),
                  cls: "py-3"
                }, null, 8, ["value", "disabled", "dateLabel", "timeLabel"])
              ]),
              (_ctx.validationErrorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("small", _hoisted_14, _toDisplayString(_ctx.validationErrorMessage), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.eventRecord.type === 'planned')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveEvent())),
                      type: "button",
                      class: _normalizeClass([{ error: 'bg-gray-100' }, "inline-flex items-center rounded-md border border-transparent bg-green-400 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"]),
                      disabled: _ctx.validationErrorMessage
                    }, _toDisplayString(_ctx.$t("buttons.apply")), 9, _hoisted_16)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.mode === 'edit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_component_PlannerComments, {
          sourceId: _ctx.eventRecord.sourceId,
          key: _ctx.plannerCommentsKey,
          onCommentAdded: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('commentAdded', $event))),
          onCommentDeleted: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('commentDeleted', $event)))
        }, null, 8, ["sourceId"]))
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}